<template>
  <v-app>
    <AppHeader />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import AppHeader from '@/components/common/AppHeader.vue';

  export default defineComponent({
    name: 'AuthLayout',
    components: {
      AppHeader,
    },
  });
</script>
